import { render, staticRenderFns } from "./ProductUsersField.vue?vue&type=template&id=4db2f67f"
import script from "./ProductUsersField.vue?vue&type=script&lang=js"
export * from "./ProductUsersField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports